import type { QueryClient } from 'react-query'

export async function invalidateFeedQueries(
  queryClient: QueryClient,
  projectId: string,
): Promise<void> {
  await Promise.all([
    queryClient.invalidateQueries(['trend-feed-issues', projectId]),
    queryClient.invalidateQueries(['trend-feed-updates', projectId]),
    queryClient.invalidateQueries([
      'trend-feed-previously-detected',
      projectId,
    ]),
  ])
}
